import { Rating, styled } from '@/shared/ui/mui';
/**
 * StyledRating - A rating component styled with primary theme color
 *
 * Features:
 * - Purple filled stars (primary theme color)
 * - Consistent with brand identity
 * - Ready to use for reviews, ratings, etc.
 *
 * Usage:
 * ```tsx
 * <StyledRating
 *   value={4.5}
 *   precision={0.5}
 *   readOnly
 *   size="small"
 * />
 * ```
 */
export const StyledRating = styled(Rating)(({ theme }) => ({
  '& .MuiRating-iconFilled': {
    color: theme.palette.primary.main,
  },
}));
